import { render, staticRenderFns } from "./wuyeFeeReduce.vue?vue&type=template&id=5ac87e6a&scoped=true&"
import script from "./wuyeFeeReduce.vue?vue&type=script&lang=js&"
export * from "./wuyeFeeReduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac87e6a",
  null
  
)

export default component.exports